import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: theme.spacing(1.5),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    '& .MuiChip-label': {
      padding: 0,
    },
    '&.MuiChip-outlined': {
      '&:hover, &:focus, &:active': {
        backgroundColor: theme.palette.primary.lighter,
        color: theme.palette.primary.light,
      },
    },
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  selected: {
    backgroundColor: theme.palette.primary.lighter,
    color: theme.palette.primary.light,
  },
}))

export default useStyles
